module.exports = __webpack_public_path__ + "static/media/14.050b8e02.jpeg";